const SW_ACTION = {
    CLEAR_ALL: 'CLEAR_ALL',
    DISPATCH: 'DISPATCH',
    READ_OFFLINE: 'READ_OFFLINE',
    SET_USER_TOKEN: 'SET_USER_TOKEN',
    TEST_NOTIFICATION: 'TEST_NOTIFICATION',
    TRANSITION_TO: 'TRANSITION_TO',
    UPDATE_LOCATION: 'UPDATE_LOCATION',
};

const API_ACTION = {
    USER_GET: 'USER_GET',
    LISTINGS_UPDATE: 'LISTINGS_UPDATE',
    LEADS_FOR_LISTING: 'LEADS_FOR_LISTING',
    PROPERTY_DETAILS: 'PROPERTY_DETAILS',
    LEAD_DETAILS: 'LEAD_DETAILS',
};

const COOKIE = {
    ZG_SW_REGISTERED: 'ZG_SW_REGISTERED',
    ZG_MODAL_NOTIFICATION_PROMPT_DISPLAY_DECLINED: 'ZG_MODAL_NOTIFICATION_PROMPT_DISPLAY_DECLINED',
};

const DOMAIN_WHITE_LIST = [
    'photonet.hotpads.com',
    'nodes3cdn.hotpads.com',
];

// 3rd party (opaque) requests
const OUT_OF_SCOPE_ASSET_LIST = [
    'https://storage.googleapis.com/workbox-cdn/releases/3.4.1/workbox-sw.js',
];

const ENDPOINT_TO_REQUEST_WHITE_LIST = {
    '/rental-manager/proxy/rental-manager-api/api/v2/users/properties/listings': API_ACTION.LISTINGS_UPDATE,
    // '/rental-manager-api/api/v1/users/leads/leadsForListing': API_ACTION.LEADS_FOR_LISTING,
    // '/rental-manager-api/api/v1/users/properties/details': API_ACTION.PROPERTY_DETAILS,
    // '/rental-manager-api/api/v1/users/leads/details': API_ACTION.LEAD_DETAILS,
};

const WHITE_LIST = [].concat(DOMAIN_WHITE_LIST);

export {
    API_ACTION,
    COOKIE,
    DOMAIN_WHITE_LIST,
    ENDPOINT_TO_REQUEST_WHITE_LIST,
    OUT_OF_SCOPE_ASSET_LIST,
    WHITE_LIST,
    SW_ACTION,
};
